export const generateJobSlug = (item) => {
    if (!item) return '';
    
    // Extract ID
    const id = item.jobPostId || item.jobId || item.id;
    if (!id) return '';
    
    // Extract Job Title
    const title = item.jobTitle || item.title || '';
    
    // Extract Company Name
    let company = '';
    if (item.jobCompanyId && typeof item.jobCompanyId === 'object') {
        company = item.jobCompanyId.name || '';
    } else if (item.companyName) {
        company = item.companyName;
    } else if (item.company) {
        company = typeof item.company === 'object' ? item.company.name : item.company;
    }
    
    // Extract Location City
    let city = '';
    if (item.jobLocationId && typeof item.jobLocationId === 'object') {
        city = item.jobLocationId.city || '';
    } else if (item.jobLocation) {
        city = item.jobLocation.split(',')[0].trim();
    } else if (item.location) {
        city = typeof item.location === 'object' ? (item.location.city || '') : item.location.split(',')[0].trim();
    }
    
    // Fallback if all are empty
    if (!title && !company && !city) {
        return `${id}`;
    }
    
    const parts = [];
    if (title) parts.push(title);
    if (company) parts.push(`at ${company}`);
    if (city) parts.push(city);
    
    const slugText = parts.join(' ')
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // remove special characters
        .trim()
        .replace(/\s+/g, '-')         // replace spaces with hyphens
        .replace(/-+/g, '-');         // remove double hyphens
        
    return `${slugText}-${id}`;
};

export const getJobUrl = (item) => {
    const slug = generateJobSlug(item);
    return slug ? `/jobs/${slug}` : '/jobs';
};
